import { splitsList } from '../../../../constants';

const coreDefault = 'off';

const splitNames = Object.values(splitsList);

const defaultTestConfiguration = {
  default: 'off',
  111111111111: 'on',
};

const map = {
  [splitsList.prodmoveDD]: { default: 'off', 111222333444: 'on' },
  [splitsList.breachPlus]: defaultTestConfiguration,
  [splitsList.fullCreditReportIdPlus]: defaultTestConfiguration,
  [splitsList.fullCreditReportBreachPlus]: defaultTestConfiguration,
  [splitsList.fullCreditReportBreach]: defaultTestConfiguration,
  [splitsList.fullCreditReportFree]: defaultTestConfiguration,
  [splitsList.prodmoveNebulaNav]: {
    default: 'off',
    99999999999: 'on',
  },
  'current-account-navigation': {
    default: 'on',
  },
  'savings-account-navigation': {
    default: 'on',
  },
  [splitsList.productMovementBreachExtension]: {
    default: 'on',
    99999999998: 'on',
  },
  [splitsList.applePay]: {
    default: 'on',
    111111111111: 'on',
  },
  [splitsList.protectWebRollout]: {
    default: 'off',
    10000000000: 'protect_control',
    10000000001: 'on',
  },
  [splitsList.applePayWebRollout]: {
    default: 'on',
  },
  [splitsList.googlePayWebRollout]: {
    default: 'on',
  },
  [splitsList.webChangeBillingDate]: {
    default: 'on',
  },
  [splitsList.annualPricing]: {
    default: 'on',
  },
  [splitsList.flutterCbdToggle]: {
    default: 'on',
  },
  [splitsList.AvatarProfileMPVExperience]: {
    default: 'off', // default behaviour
  },
  [splitsList.idDownsellRetention]: {
    default: 'off',
  },
  [splitsList.webNewChangePaymentMethod]: {
    default: 'off',
  },
  [splitsList.billingDeclineIncidentJuly25]: {
    default: 'off',
  },
  [splitsList.billingIncidentModalPaymentChange]: {
    default: 'off',
  },
  [splitsList.prodmoveNewDesign]: {
    default: 'on',
  },
  [splitsList.isFlexSplitEnabled]: {
    default: 'on',
  },
};

export default (customerNumber, splits = splitNames, splitMap = map) =>
  splits.reduce((_splits, split) => {
    const mappedSplits = _splits;
    mappedSplits[split] = splitMap[split]?.[customerNumber] || splitMap[split]?.default || coreDefault;
    return mappedSplits;
  }, {});
